import {
  accommodationTotalPrices,
  accommodationTotalPricesToCheckout,
} from 'utils/accommodationUtils';
import { additionalServicesTotalPrices } from 'utils/additionalServicesUtils';
import {
  courseTotalPrices,
  courseTotalPricesToCheckout,
} from 'utils/courseUtils';
import { packageTotalPrices } from 'utils/packageUtils';

export const getSummary = (selectItems) => {
  let coursePrices = {
    discount: 0,
    price: 0,
    priceWithDiscount: 0,
    registrationFee: 0,
    supplementPrice: 0,
    supplementPriceExchanged: 0,
    total: 0,
    totalDiscount: 0,
    totalDiscountExchanged: 0,
    totalExchanged: 0,
  };

  if (selectItems?.courses && selectItems.courses.length > 0)
    coursePrices = courseTotalPrices(selectItems?.courses[0]);

  const accommodationPrices = accommodationTotalPrices(
    selectItems?.accommodationGroups[0]
  );
  const pkg = packageTotalPrices(selectItems?.packages);

  const exchangeRate = coursePrices?.exchangeRate || pkg?.exchangeRate;

  const additionalServicePrices = additionalServicesTotalPrices(
    selectItems?.additionalServices,
    selectItems?.insurances,
    selectItems?.courseWeeks,
    exchangeRate
  );

  const discount =
    coursePrices?.discount + accommodationPrices?.discount + pkg?.discount;

  const supplementPrice =
    coursePrices?.supplement + accommodationPrices?.supplement;

  return {
    accommodationFeeExchanded: accommodationPrices?.registrationFeeExchanded,
    accommodationPrice: accommodationPrices?.total,
    accommodationSupplementExchanged: accommodationPrices?.supplement,
    additionalPrice: additionalServicePrices?.totalExchanged,
    bookChargedBefore: coursePrices?.bookChargedBefore,
    bookMaterial: coursePrices?.bookMaterial,
    bookNote: coursePrices?.bookNote,
    coursePrice: coursePrices?.total,
    courseSupplementExchanged: coursePrices?.courseSupplementExchanged,
    currency: selectItems?.currency,
    discount,
    exchangeRate,
    registrationFeeExchanded: coursePrices?.registrationFeeExchanded,
    supplementPrice,
    registrationFeeWithDiscountExchanged:
      coursePrices?.registrationFeeWithDiscountExchanged,
    accommodationFeeWithDiscountExchanded:
      accommodationPrices?.registrationFeeWithDiscountExchanged,
    total:
      accommodationPrices?.total +
      additionalServicePrices?.total +
      coursePrices?.total +
      pkg?.total,
    totalDiscount:
      accommodationPrices?.totalDiscount +
      additionalServicePrices?.total +
      coursePrices?.totalDiscount +
      pkg?.totalDiscount,
    totalExchanged:
      accommodationPrices?.totalExchanged +
      additionalServicePrices?.totalExchanged +
      coursePrices?.totalExchanged +
      pkg?.totalExchanged,
    totalDiscountExchanged:
      accommodationPrices?.totalDiscountExchanged +
      additionalServicePrices?.totalExchanged +
      coursePrices?.totalDiscountExchanged +
      pkg?.totalDiscountExchanged,
  };
};

// Remove this function and the other when the following task is completed https://app.clickup.com/t/8678awk6k
export const getSummaryToCheckout = (summaryItems) => {
  let coursePrices = {};

  const accommodationPrices = accommodationTotalPricesToCheckout(summaryItems);

  if (summaryItems?.courses.length > 0)
    coursePrices = courseTotalPricesToCheckout(summaryItems);

  const additionalServicePrices = additionalServicesTotalPrices(
    summaryItems?.additionalServices,
    summaryItems?.insurances,
    summaryItems?.courses[0]?.weekQuantity,
    coursePrices?.exchangeRate
  );

  const discount = coursePrices?.discount + accommodationPrices?.discount;

  summaryItems.discount = discount;
  summaryItems.totalDiscount =
    accommodationPrices?.totalExchanged +
    additionalServicePrices?.totalExchanged +
    coursePrices?.totalExchanged;

  return {
    discount,
    totalDiscount:
      accommodationPrices?.totalExchanged +
      additionalServicePrices?.totalExchanged +
      coursePrices?.totalExchanged,
  };
};
